import { EmptyState } from "@similarweb/ui-components";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { translate } from "app/filters/i18nFilter";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";

import { CompetitorsSectionContent } from "./CompetitorsSectionContent";

export const CompetitorsSectionRoot = () => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                isEmpty
                dataAutomation="competitors-tab"
                renderContent={() => (
                    <EmptyState
                        title={translate("si.company-analysis.company-data.card.empty.header")}
                        subtitle={translate("si.company-analysis.company-data.card.empty.text")}
                    />
                )}
                header={
                    <CardHeader
                        title={translate("si.company-analysis.competitors.card.header")}
                        infoTooltip={translate("si.company-analysis.competitors.card.header.info-tooltip")}
                    />
                }
            />
        }
    >
        <CompetitorsSectionContent />
    </ErrorBoundaryWithLogging>
);
